import React, { useState, useRef, useEffect } from "react";
import DropDownIcon from "../../../Assets/Images/EployeeRegistration/icon-dropdown-menu.png";

export default function DropDown({
  width,
  label,
  selected,
  setSelected,
  options,
  customWidth,
  customTop,
  isRequired,
  Height,
  OverFlow,
  minheight,
  placeholder = "",
  marginLeft,
  marginTop,
}) {
  const [isActive, setIsActive] = useState(false);
  const [selectedLabel, setSelectedLabel] = useState(placeholder); // Default to placeholder
  const dropdownRef = useRef(null);

  //  Sync `selectedLabel` with `selected` on first render or when `selected` changes
  useEffect(() => {
    if (selected) {
      const selectedOption = options.find((option) => option.id === selected);
      if (selectedOption) {
        setSelectedLabel(selectedOption.label);
      }
    }
  }, [selected, options]); // No `placeholder` dependency to prevent unnecessary resets

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsActive(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleClick = (option) => {
    setSelected(option.id);
    setSelectedLabel(option.label); //  Update label when user selects an option
    setIsActive(false);
  };

  return (
    <div className="dropdown" style={{ width, marginLeft, marginTop }} ref={dropdownRef}>
      <label>
        {label}
        {/* {(isRequired || label === "Difficulty Level") && <span style={{ color: 'red' }}>*</span>} */}
        {isRequired && <span>*</span>}
      </label>
      <div className="dropdown-btn" onClick={() => setIsActive(!isActive)}>
        {selectedLabel || placeholder} {/*  Prevents reset to placeholder */}
        <img src={DropDownIcon} alt="dropdown-icon" />
      </div>
      {isActive && (
        <div
          className="dropdown-content"
          style={{
            width: customWidth,
            top: customTop,
            maxHeight: minheight,
            height: Height,
            overflow: OverFlow,
          }}
        >
          {options.map((option) => (
            <div
              key={option.id}
              className="dropdown-item"
              onClick={() => handleClick(option)}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
